<div *ngIf="fts.selectedOffers">
  <div class="upper-part-options unselectable">
    <div class="filter-results-button" (click)="showFilterMenu()">
      {{ "FILTER_RESULTS" | translate | uppercase }}
    </div>
    <div class="currency-container">
      <div
        class="currency-type-container"
        [class.selected]="offersService.selectedCurrency === 'EUR'"
        (click)="offersService.changeSelectedCurrencyTo('EUR')"
      >
        EUR
      </div>
      <div class="currency-type-container"
        [class.selected]="offersService.selectedCurrency === 'BGN'"
        (click)="offersService.changeSelectedCurrencyTo('BGN')"
      >
        {{ "LEVA" | translate | uppercase }}
      </div>
    </div>
    <div class="sort-container" [class.hidden]="fts.selectedOffers.length < 2">
      <div class="sort-by-price-container">
        <div class="sort-by-price-ascending" (click)="sortByPrice('ascending')">
          &#x25B2;
        </div>
        <div class="sort-by-price-text">
          {{ "PRICE" | translate | uppercase }}
        </div>
        <div
          class="sort-by-price-descending"
          (click)="sortByPrice('descending')"
        >
          &#x25BC;
        </div>
      </div>
      <div class="sort-by-space-container">
        <div class="sort-by-space-ascending" (click)="sortBySpace('ascending')">
          &#x25B2;
        </div>
        <div class="sort-by-space-text">
          {{ "SPACE" | translate | uppercase }}
        </div>
        <div
          class="sort-by-space-descending"
          (click)="sortBySpace('descending')"
        >
          &#x25BC;
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="paginator-container" [class.hidden]="maxPages < 2">
      <div
        class="arrow-previous-page all-cells"
        [class.disabled]="selectedFilteredPageIndex === 1"
        (click)="clickPreviousPage()"
      >
        <div class="cell-text"><<</div>
      </div>
      <div
        class="page-number all-cells"
        (click)="clickPageIndex(1)"
        [class.page-selected]="selectedFilteredPageIndex === 1"
      >
        <div class="cell-text">1</div>
      </div>
      <div class="left-dots all-cells" [class.hidden]="!canShowLeftDots">
        <div class="cell-text">...</div>
      </div>
      <div
        class="page-number all-cells"
        *ngFor="let page of middlePages"
        (click)="clickPageIndex(page)"
        [class.page-selected]="selectedFilteredPageIndex === page"
      >
        <div class="cell-text">
          {{ page }}
        </div>
      </div>
      <div class="right-dots all-cells" [class.hidden]="!canShowRightDots">
        <div class="cell-text">...</div>
      </div>
      <div
        class="page-number all-cells"
        (click)="clickPageIndex(maxPages)"
        [class.page-selected]="selectedFilteredPageIndex === maxPages"
      >
        <div class="cell-text">
          {{ maxPages }}
        </div>
      </div>
      <div
        class="arrow-next-page all-cells"
        [class.disabled]="selectedFilteredPageIndex === maxPages"
        (click)="clickNextPage()"
      >
        <div class="cell-text">>></div>
      </div>
    </div>
  </div>

  <div class="offers-container">
    <app-offer-preview
      class="unselectable"
      *ngFor="let offer of shownOffers"
      [offer]="offer"
    ></app-offer-preview>
  </div>

  <div
    class="filtered-offers-menu-overlay"
    [class.show-overlay]="offersFilterVisible"
  ></div>
  <div class="bottom-part-options unselectable">
    <div class="paginator-container" [class.hidden]="maxPages < 2">
      <div
        class="arrow-previous-page all-cells"
        [class.disabled]="selectedFilteredPageIndex === 1"
        (click)="clickPreviousPage()"
      >
        <div class="cell-text"><<</div>
      </div>
      <div
        class="page-number all-cells"
        (click)="clickPageIndex(1)"
        [class.page-selected]="selectedFilteredPageIndex === 1"
      >
        <div class="cell-text">1</div>
      </div>
      <div class="left-dots all-cells" [class.hidden]="!canShowLeftDots">
        <div class="cell-text">...</div>
      </div>
      <div
        class="page-number all-cells"
        *ngFor="let page of middlePages"
        (click)="clickPageIndex(page)"
        [class.page-selected]="selectedFilteredPageIndex === page"
      >
        <div class="cell-text">
          {{ page }}
        </div>
      </div>
      <div class="right-dots all-cells" [class.hidden]="!canShowRightDots">
        <div class="cell-text">...</div>
      </div>
      <div
        class="page-number all-cells"
        (click)="clickPageIndex(maxPages)"
        [class.page-selected]="selectedFilteredPageIndex === maxPages"
      >
        <div class="cell-text">
          {{ maxPages }}
        </div>
      </div>
      <div
        class="arrow-next-page all-cells"
        [class.disabled]="selectedFilteredPageIndex === maxPages"
        (click)="clickNextPage()"
      >
        <div class="cell-text">>></div>
      </div>
    </div>
  </div>
  <div
    class="offers-filter-container"
    id="offers-filter"
    [class.show-offers-filter]="offersFilterVisible"
  >
    <app-offer-search
      [hidden]="!offersFilterVisible"
      (close)="hideFilterMenu()"
    >
    </app-offer-search>
  </div>
</div>
